import React from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Col, Row } from 'reactstrap';
import Api from "../../services/api";
import { ToastContainer, toast } from 'react-toastify';
import "./style.css"
import { FaCheckCircle, FaExclamationCircle } from 'react-icons/fa';

export default class Improvement extends React.Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            activeTab: null,
            strength: '',
            weakness: '',
            opportunity: '',
            threats: '',
            categories: '',
            fyId: '',
            catId: '',
            userToken: '',
            gnid: '',
            improvements: '',
            activeData: null,
            isCommented: false
        };
        this.handleSubmit = this.handleSubmit.bind(this);
    }



    handleSubmit = async (e) => {
        e.preventDefault();
        // console.log(this.state);
        // console.log("this.state.fyId", this.state.fyId)
        try {
            let data = await Api.getAddImprovements({
                fiscal_year_id: this.state.fyId,
                strength: this.state.strength,
                weakness: this.state.weakness,
                opportunity: this.state.opportunity,
                threats: this.state.threats,
                category_id: this.state.catId
            });
            if (data.code === 200) {
                toast.success(data.message, {
                    position: toast.POSITION.TOP_CENTER,
                });
                this._getImprovement();
                // this.setState(prevState => ({
                //     improvements: prevState.improvements.map(improvement => {
                //         if (improvement.category_id === this.state.catId) {
                //             return {
                //                 ...improvement,
                //                 isCommented: true
                //             };
                //         }
                //         console.log("previousState", prevState)
                //         return improvement;

                //     })
                // }))

                // this.setState({ activeData: data.response, strength: data.response.strength, weakness: data.response.weakness, opportunity: data.response.opportunity, threats: data.response.threats, isCommented: data.response.isCommented })
                // console.log(this.state)

                // console.log("this.state.catId", this.state.catId)
                // console.log("improvements", this.state.improvements.find(improvement => improvement.category_id = this.state.catId))
                // // this.state.improvements.find(improvement => improvement.category_id === this.state.catId).isCommented = false
                // console.log("latestimp", this.state.improvements.find(improvement => improvement.category_id === this.state.catId).isCommented)
                // console.log("lastimprovements", this.state.improvements)

            } else {
                toast.error(data.message, {
                    position: toast.POSITION.TOP_CENTER,
                });

            }
        } catch (error) {
            console.error("Error while posting improvement data:", error);
        }
    }

    _getHomeData = async () => {
        const { fiscal_year_id } = this.props;
        let homeRes = await Api.getCategories({});

        if (/* A variable that is used to store the response of the API call. */
            homeRes && homeRes.response) {
            this.setState({
                categories: homeRes.response
            });
        }
    }

    async componentDidMount() {
        let localData = this.props.fiscal_year_id
        let fiscal = localStorage.getItem('fiscalYear');
        let ldata = JSON.parse(localStorage.user)
        let gnid = ldata.user.gnid

        // console.log("fiscalYear", localStorage.getItem('fiscalYear'))
        // console.log("this.props.fiscal_year_id", ldata.user.fiscal_year_id)

        await this.setState({
            fyId: ldata.user.fiscal_year_id ? ldata.user.fiscal_year_id : fiscal,
            gnid: gnid
        })
        this._getHomeData();
        this._getImprovement();
        this.setState({ activeTab: 24 })
        // console.log("localStorage", gnid)

    }


    componentDidUpdate(prevProps, prevState) {
        // console.log("prevProps", prevProps);
        // console.log("prevstate", prevState);
        // console.log("this.state.activeTab", this.state.activeTab);
        if (this.state.activeTab !== prevState.activeTab || this.state.improvements !== prevState.improvements) {
            // console.log("setting");
            const filterData = this.state.improvements && this.state.improvements.find((improvement) => {
                return improvement.category_id === this.state.activeTab
            })

            // console.log("filterData", filterData);
            if (filterData) {
                this.setState({ activeData: filterData, strength: filterData.strength, weakness: filterData.weakness, opportunity: filterData.opportunity, threats: filterData.threats, isCommented: filterData.isCommented })
            } else {
                this.setState({ activeData: null, strength: " ", weakness: " ", opportunity: " ", threats: " ", isCommented: false })

            }
        }
    }

    _getImprovement = async () => {
        const { gnid, fyId } = this.state;
        try {
            let data = await Api.getImprovements(gnid, fyId);
            if (data && data.response) {
                const updatedImprovements = data.response.map(improvement => {
                    if (improvement.strength !== "" && improvement.weakness !== "" && improvement.opportunity !== "" && improvement.threats !== "") {
                        // console.log("completed");
                        return { ...improvement, isCommented: true };
                    } else {
                        // console.log("completed-n");

                        return { ...improvement, isCommented: false };
                    }
                });
                this.setState({
                    improvements: updatedImprovements
                });
            }
        } catch (error) {
            console.error("Error while getting improvement data:", error);
        }
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    navLinkStyles = {
        backgroundColor: "white",
        color: "purple",
        position: "relative",
        display: "flex",


    };
    render() {
        const { categories, isCommented, improvements } = this.state;
        // { console.log("improvements", this.state.improvements[0] && this.state.improvements[0].category_id) }
        return (
            <div>

                <Row className=' mt-4'>
                    <ToastContainer />


                    <Col sm="3" className={'bg-white'}>
                        <h1 className='sub-heading pt-4'>लैससास विश्लेषण</h1>
                        {/* <h5 className='pt-4 sub-heading'>Heading</h5> */}
                        <Nav vertical style={{ width: "100%" }}>
                            {categories && categories.map((category, index) => {
                                let improvement = this.state.improvements && this.state.improvements.find((improvement) => +improvement.category_id === +category.id);
                                return <NavItem key={category.id} style={{ textColor: "purple" }}>
                                    <NavLink

                                        className={this.state.activeTab === category.id ? "nav-link-purple-border" : "nav-link-ordinary"}
                                        onClick={() => {
                                            this.toggle(category.id);
                                            // this.state.activeTab = category.id;
                                        }}>
                                        {category.name}
                                        {improvement && improvement.isCommented ? <FaCheckCircle
                                            className="check-circle-icon mx-2 "
                                            color="#28a745"
                                        /> : <FaExclamationCircle
                                            className="check-circle-icon mx-2"
                                            color="#e12a2a"
                                        />}
                                        {/* {console.log("isCompleted", category.isCompleted)} */}

                                    </NavLink>
                                </NavItem>
                            })}

                        </Nav>
                    </Col>
                    <Col sm="9">
                        <TabContent activeTab={this.state.activeTab}>
                            {categories && categories.map((category) => {
                                if (category.id === this.state.activeTab) {


                                    return (
                                        <TabPane key={category.id} tabId={category.id}>

                                            <div className='bg-white p-4' >
                                                <h5 className='pb-1 sub-heading'>{category.name}</h5>
                                                <form onSubmit={(e) => {
                                                    this.state.catId = category.id
                                                    this.handleSubmit(e);
                                                    // console.log(category.id)
                                                }} className='col d-flex flex-wrap'>
                                                    <div className='col-6'>
                                                        <label className=''>सबल पक्षहरू:</label>
                                                        <textarea required className='form-control bg-light' value={this.state.strength} onChange={(e) => this.setState({ strength: e.target.value })} />
                                                    </div>
                                                    <div className='col-6'>
                                                        <label>सुधार गर्नुपर्ने पक्षहरू</label>
                                                        <textarea required className='form-control bg-light' value={this.state.weakness} onChange={(e) => this.setState({ weakness: e.target.value })} />
                                                    </div>
                                                    <div className='col-6'>
                                                        <label>अवसर:</label>
                                                        <textarea required className='form-control bg-light' value={this.state.opportunity} onChange={(e) => this.setState({ opportunity: e.target.value })} />
                                                    </div>
                                                    <div className='col-6'>
                                                        <label>चुनौति:</label>
                                                        <textarea required type="" className='form-control bg-light' value={this.state.threats} onChange={(e) => this.setState({ threats: e.target.value })} />
                                                    </div>
                                                    <div className="form-group col-12 d-flex justify-content-end mt-3">
                                                        <button type="submit" className="btn btn-primary">Submit</button>
                                                    </div>
                                                </form>

                                            </div>
                                        </TabPane>
                                    )
                                }
                            }

                            )}

                        </TabContent>
                    </Col>


                </Row>
            </div>

        );
    }
}
